/* eslint-disable no-useless-escape */
export const defaultDateTimeFormat = 'DD/MM/YYYY HH:mm';

export const APIdateFormat = 'YYYY-MM-DD';

export const validityPeriodTimeFormat = 'YYYY-MM-DD HH:mm:ss';

export const defaultTimeFormat = 'HH:mm';

export const defaultDateFormat = 'DD/MM/YYYY';

export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const urlRegex =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

export const numberRegex = /\d+/g;
export const lettersRegex = /[a-zA-Z]+/g;
export const versionRegex = /^v?\d+(\.\d+){0,2}$/;

export const validationTimeDefault = 300;
export const validationTimeLong = 1000;

export const errorMsg = {
  alphanumeric: 'Use lowercase characters and numbers only',
  consumptionBiggerThanZero:
    'Selected consumption values have to be bigger than zero',
  customerRequiredAssignManager:
    'Select customer if you want to assign it as license manager',
  cfsInvalidValue: 'Custom field is missing a value',
  codeDuplicate: 'This code is already in use',
  codeMaxChars: 'Product code can have max 20 characters',
  companyDuplicate: 'This company name is already in use',
  dateYYYYMMDDformat: 'Please enter date in YYYY-MM-DD format',
  emailDuplicate: 'This email is already in use',
  globalError: 'There was an error, please try again later',
  longHash: "File hash  can't have more than 32 characters",
  invalidData: 'Enter valid data',
  invalidEmail: 'Enter valid email',
  invalidEmails: 'Enter valid emails',
  invalidJson: 'Invalid JSON',
  invalidJsonObject: 'Invalid JSON object',
  invalidUrl: 'Enter valid URL',
  invalidVersionFormat:
    'Version should consist of max 3 numbers separated with a dot and optional `v` in front - ex: 1.2.3, v1.2, 0.0.1',
  maxActivations:
    'Max activations number cannot be lower than max license users',
  maxActivationsDevices:
    'Number of max activations is less than the number of currently active devices – please deactivate one or more devices before decreasing the number of activations.',
  maxChars: 'Max allowed characters count for this field:',
  maxSimultaneousUsers:
    'Max simultaneous license users number cannot be higher than max activations',
  maxQuantity: 'Max allowed quantity is: ',
  nameDuplicate: 'This product name is already in use',
  nameDuplicateGeneric: 'This name is already in use',
  nameArchivedDuplicate:
    'Product with this is name is archived. Change the name or activate archived product.',
  notAssigned: 'Not assigned',
  passCharNum: 'Password should contain at least 12 characters',
  passCurrent: 'Enter your current password',
  passLowercase: 'Password should contain at least 1 lowercase letter',
  passMatch: 'Passwords do not match',
  passNumber: 'Password should contain at least 1 number',
  passSpecialChar:
    'Password should contain at least 1 special character (!@#^&*)',
  passUppercase: 'Password should contain at least 1 uppercase letter',
  remainingLicenses: 'Remaining licenses to issue: ',
  required: 'This field is required',
  requiredFile: 'This file is required',
  selectCustomer: 'Select customer from the dropdown',
  selectErr: 'Select from dropdown',
  tooManyEmails:
    'You have entered too many emails, check your max license users number input',
  unsubmittedEmail:
    'In order to submit a user email, please add the email address of your desired user and press enter',
  userDuplicate: 'A user is already a member of this company.',
};

export const searchType = {
  licenseUserEmail: 'license_users__true_email__icontains',
  licenseKey: 'license_key__icontains',
  licenseID: 'id__in',
  order_storeID: 'store_id__icontains',
  managerEmail: 'manager_email',
  orderID: 'order__store_id__icontains',
  productName: 'product_name__icontains',
  hostname: 'devices__hostname__icontains',
  customerEmail: 'customer_email',
  customerCompany: 'customer_company_name__icontains',
  note: 'note__icontains',
};

// export const searchType = {
//   license: 'license',
//   order: 'store_id',
//   user: 'customer__email',
//   email: 'email',
//   licenseNumber: 'license_key',
//   licenseUserEmail: 'license_user.true_email',
//   customerCompany: 'customer_company_name',
//   customerReference: 'customer_reference',
//   customerName: 'customer_name',
//   firstName: 'first_name',
//   lastName: 'last_name',
//   phoneNumber: 'phone',
//   companyName: 'company_name',
//   productName: 'product_name',
//   productCode: 'short_code',
// };

export const licenseUsageTypes = [
  {
    value: 'all',
    label: 'All licenses',
  },
  {
    value: 'node_locked_key',
    label: 'Node locked key auth licenses',
  },
  {
    value: 'node_locked_user',
    label: 'Node locked user auth licenses',
  },
  {
    value: 'floating_key',
    label: 'Floating key auth licenses',
  },
  {
    value: 'floating_user',
    label: 'Floating user auth licenses',
  },
];

export const initialPortalData = {
  topHeaderBackground: '#555555',
  sidebarBackground: '#ffffff',
  pageBackground: '#fafafa',
  showProductLinks: false,
  allowUsersLicenseReset: true,
  allowUsersLicenseBorrow: false,
  loginTitle: '',
  loginMessage: '',
};

export const environmentOptions = [
  { label: 'Linux 32/64', value: 'linux' },
  { label: 'Linux 32', value: 'linux32' },
  { label: 'Linux 64', value: 'linux64' },
  { label: 'Mac OS', value: 'mac' },
  { label: 'Windows 32/64', value: 'win' },
  { label: 'Windows 32', value: 'win32' },
  { label: 'Windows 64', value: 'win64' },
];

export const managerPermissionDescription = {
  create_license_policy: 'Can create new license policies',
  create_order: 'Can create new orders',
  issue_license: 'Can issue new licenses on existing order',
  manage_license_users: 'Can add, edit or delete license users',
  manage_license_user_credentials: 'Can change license users passwords',
  manage_managers: 'Can add new license managers to some order',
  reset_device: 'Can reset device',
  reset_license: 'Can reset license',
  show_license_usage_report:
    'Can see the activity report ( number of created orders and issued licenses )',
  manage_license_oauth_clients: 'Can manage license OAuth credentials',
  show_license_oauth_clients: 'Can see license OAuth credentials',
  edit_customer: 'Can edit existing order customer',
  edit_license: 'Can edit existing license details',
  edit_license_custom_fields: 'Can edit custom fields on existing license',
  edit_license_product_features:
    'Can edit product features on existing license',
  manage_customer_accounts: 'Can manage customer accounts',
  manage_user_groups: 'Can manage license user groups',
};

export const productFeatureTypes = {
  activation: 'activation',
  consumption: 'consumption',
};

export const licenseTypes = {
  perpetual: 'perpetual',
  subscription: 'subscription',
  time_limited: 'time-limited',
  consumption: 'consumption',
};

export const authMethods = {
  key: 'license-key',
  user: 'user',
};

export const platformFeatures = {
  assignment_key: 'assignment:key',
  assignment_user: 'assignment:user',
  deployment_maintenance: 'deployment:maintenance',
  deployment_product_upgrades: 'deployment:product-upgrades',
  deployment_product_versioning: 'deployment:product-versioning',
  deployment_single_tenancy: 'deployment:single-tenancy',
  deployment_self_hosted: 'deployment:self-hosted',
  extra_global_feature_licensing: 'extra:global-feature-licensing',
  extra_custom_fields: 'extra:custom-fields',
  extra_device_variables: 'extra:device-variables',
  extra_feature_licensing: 'extra:feature-licensing',
  extra_feature_licensing_activation: 'extra:feature-licensing-activation',
  extra_feature_licensing_consumption: 'extra:feature-licensing-consumption',
  extra_feature_group_licensing: 'extra:feature-group-licensing',
  extra_feature_expiry_date: 'extra:feature-expiry-date',
  extra_account_based_licensing: 'extra:account-based-licensing',
  extra_air_gapped: 'extra:air-gapped',
  extra_hardware_token: 'extra:hardware-token',
  extra_license_borrowing: 'extra:license:borrowing',
  extra_prevent_vm: 'extra:prevent-vm',
  extra_max_transfers: 'extra:max-transfers',
  extra_max_activations: 'extra:max-activations',
  extra_product_bundle: 'extra:product-bundle',
  extra_single_sign_on: 'extra:single-sign-on',
  extra_distribution_portal: 'extra:distribution-portal',
  extra_whitelabeling: 'extra:whitelabeling',
  extra_audit_log: 'extra:audit-log',
  extra_webhooks: 'extra:webhooks',
  extra_multiple_api_keys: 'extra:multiple-api-keys',
  extra_oauth: 'extra:oauth',
  extra_license_start_date: 'extra:license-start-date',
  extra_metadata: 'extra:metadata',
  extra_license_policy_count: 'extra:license-policy-count',
  extra_license_policy_update: 'extra:license-policy-update',
  extra_flaoting_features: 'extra:floating-features',
  extra_user_portal: 'extra:user-portal',
  extra_offline_portal: 'extra:offline-portal',
  extra_airgap_portal: 'extra:airgap-portal',
  extra_management_api: 'extra:management-api',
  extra_management_api_readonly: 'extra:management-api-readonly',
  extra_email_notifications: 'extra:email-notifications',
  extra_email_notifications_templates: 'extra:email-notifications-templates',
  extra_analytics: 'extra:analytics',
  extra_non_prod_accounts: 'extra:non-prod-accounts',
  extra_sandbox: 'extra:sandbox',
  integrations_fastspring: 'integrations:fastspring',
  integrations_salesforce: 'integrations:salesforce',
  integrations_hubspot: 'integrations:hubspot',
  integrations_stripe: 'integrations:stripe',
  model_consumption: 'model:consumption',
  model_floating_cloud: 'model:floating-cloud',
  model_floating_on_premises: 'model:floating-on-premises',
  model_perpetual: 'model:perpetual',
  model_subscription: 'model:subscription',
  model_time_limited: 'model:time-limited',
  model_trial: 'model:trial',
  usage_mrl: 'usage:mrl',
  usage_products: 'usage:products',
  usage_sdks: 'usage:sdks',
  usage_platform_users: 'usage:platform-users',
  usage_total_active_licenses: 'usage:total-active-licenses',
  usage_online_activation: 'usage:online-activation',
  usage_offline_activation: 'usage:offline-activation',
  usage_user_groups: 'usage:user-groups',
  reporting_data_export: 'reporting:data-export',
  reporting_data_retention: 'reporting:data-retention',
  reporting_devices_view: 'reporting:devices-view',
  platform_add_license: 'platform:add-license',
  platform_edit_license: 'platform:edit-license',
  platform_edit_customer: 'platform:edit-customer',
  platform_add_user: 'platform:add-user',
  platform_edit_user: 'platform:edit-user',
  platform_add_product: 'platform:add-product',
  platform_edit_product: 'platform:edit-product',
};

// value - number or -1 (unlimited) OR null
// based on pricing page
export const defaultFeaturesList = [
  {
    key: 'usage:mrl',
    label: 'Monthly requests limit',
    value: 100000,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:products',
    label: 'Products number',
    value: 50,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:sdks',
    label: 'Sdks',
    value: 1,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:platform-users',
    label: 'Platform users',
    value: 1,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:total-active-licenses',
    label: 'Total active licenses',
    value: 100,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:online-activation',
    label: 'Online activation',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:offline-activation',
    label: 'Offline activation',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'usage:user-groups',
    label: 'User groups',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'assignment:key',
    label: 'Key based license assigment',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'assignment:user',
    label: 'User based license assigment',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'model:trial',
    label: 'Trial licenses',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'model:perpetual',
    label: 'Perpetual licenses',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'model:time-limited',
    label: 'Time limited licenses',
    value: null,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'model:subscription',
    label: 'Subscription licenses',
    value: null,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'model:floating-cloud',
    label: 'Floating licenses (cloud)',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'model:floating-on-premises',
    label: 'Floating licenses (on premises server)',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'model:consumption',
    label: 'Consumption licenses',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:floating-features',
    label: 'Floating features',
    value: 5,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:feature-licensing',
    label: 'Feature licensing',
    value: 5,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:feature-licensing-consumption',
    label: 'Feature licensing (consumption)',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:feature-licensing-activation',
    label: 'Feature licensing (activation)',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:feature-group-licensing',
    label: 'Feature group licensing',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:feature-expiry-date',
    label: 'Feature expiry date',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:account-based-licensing',
    label: 'Account based licensing',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:air-gapped',
    label: 'Air gapped licensing',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:custom-fields',
    label: 'Custom fields server-to-client',
    value: 3,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:device-variables',
    label: 'Device custom variables',
    value: 1,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:prevent-vm',
    label: 'Prevent VM',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:max-transfers',
    label: 'Device transfer limit',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:max-activations',
    label: 'Max activations per license',
    value: 100,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:single-sign-on',
    label: 'Single Sign On',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:license:borrowing',
    label: 'License borrowing',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:hardware-token',
    label: 'Hardware token',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:distribution-portal',
    label: 'Distribution portal',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:whitelabeling',
    label: 'Whitelabeling',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:audit-log',
    label: 'Audit log',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:email-notifications',
    label: 'Email notifications',
    value: null,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:email-notifications-templates',
    label: 'Email notifications templates',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:analytics',
    label: 'Usage analytics',
    value: null,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:webhooks',
    label: 'Webhooks',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:multiple-api-keys',
    label: 'Multiple API keys',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:product-bundle',
    label: 'Product bundle',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:oauth',
    label: 'oAuth authorization',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:license-start-date',
    label: 'License start date',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:user-portal',
    label: 'User portal',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:airgap-portal',
    label: 'Airgap portal',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:metadata',
    label: 'Custom metadata',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:license-policy-count',
    label: 'License policies count',
    value: 1,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:license-policy-update',
    label: 'License policies update',
    value: 1,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:offline-portal',
    label: 'Offline portal',
    value: null,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:management-api',
    label: 'Management API keys',
    value: 1,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'extra:management-api-readonly',
    label: 'Management API read-only keys',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:non-prod-accounts',
    label: 'Non production accounts',
    value: 3,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'extra:sandbox',
    label: 'Sandbox',
    value: 3,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'extra:global-feature-licensing',
    label: 'Global features',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'deployment:maintenance',
    label: 'Maintenance Period',
    value: null,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'deployment:product-versioning',
    label: 'Product Versioning',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'deployment:product-upgrades',
    label: 'Product upgrades',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'deployment:single-tenancy',
    label: 'Single tenancy',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'deployment:self-hosted',
    label: 'Self hoisted',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'integrations:fastspring',
    label: 'FastSpring integrations',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'integrations:stripe',
    label: 'Stripe integrations',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'integrations:salesforce',
    label: 'Salesforce integrations',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'integrations:hubspot',
    label: 'HubSpot integrations',
    value: null,
    is_active: true,
    plans: ['enterprise'],
  },
  {
    key: 'reporting:data-export',
    label: 'Data export',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'reporting:devices-view',
    label: 'Devices view',
    value: null,
    is_active: true,
    plans: ['business_plus', 'enterprise'],
  },
  {
    key: 'reporting:data-retention',
    label: 'Data retention policy delete',
    value: 3,
    is_active: true,
    plans: ['business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:add-license',
    label: 'Platform - add license',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:edit-license',
    label: 'Platform - edit license',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:edit-customer',
    label: 'Platform - edit customer',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:add-product',
    label: 'Platform - add product',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:edit-product',
    label: 'Platform - edit product',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:add-user',
    label: 'Platform - add user',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
  {
    key: 'platform:edit-user',
    label: 'Platform - edit user',
    value: null,
    is_active: true,
    plans: ['free', 'business_starter', 'business_plus', 'enterprise'],
  },
];

export const defaultDisabledFeatureMessage = 'This feature is disabled';

export const overageTypes = {
  custom: 'overages-custom',
  unlimited: 'overages-unlimited',
};

export const trialTypes = {
  days: 'trial_days',
  endDate: 'trial_end_date',
};

export const validityTypes = {
  duration: 'duration',
  period: 'period',
};

export const licenseResetOptions = {
  reset_validity_period: true,
  reset_maintenance_period: true,
  reset_consumptions: true,
};
